import { render, staticRenderFns } from "./SupportCard.vue?vue&type=template&id=87d7b84a&"
import script from "./SupportCard.vue?vue&type=script&lang=js&"
export * from "./SupportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports